export default __webpack_public_path__ + "static/media/1184_bp.5c50070b.svg";